import React, {useState} from 'react'
import auth0js from 'auth0-js'

import {
  Grid,
  Panel,
  FlexBox,
  Columns,
  CTAButton,
  FunnelPage,
  AlignItems,
  AppWrapper,
  ButtonType,
  FlexDirection,
  ComponentSize,
  ComponentColor,
  Heading,
  HeadingElement,
} from '@influxdata/clockface'
import LegalCheckbox from 'js/components/SignUp/LegalCheckbox'

import InfluxDataLogo from 'js/components/InfluxDataLogo'
import FunnelHeader from '../shared/FunnelHeader'
import FunnelSubheader from '../shared/FunnelSubheader'

const {auth0: auth0Config} = window.Config

interface Props {
  authConnection?: string
  email: string
  orgName: string
  token: string
}

const authenticateWithSSO = (connection: string, token: string) => {
  const auth0 = new auth0js.WebAuth({
    domain: auth0Config.domain,
    clientID: auth0Config.clientID,
    redirectUri: `${auth0Config.joinOrgRedirectURI}?token=${encodeURIComponent(
      token
    )}`,
    responseType: 'code',
  })

  return auth0.authorize({connection})
}

const JoinOrg = ({
  authConnection,
  email,
  orgName,
  token,
}: Props): JSX.Element => {
  const [isAgreeing, setAgree] = useState<boolean>(false)
  const [isError, setError] = useState<boolean>(false)

  const handleJoin = () => {
    if (!isAgreeing) {
      setError(true)
      return
    }

    if (authConnection) {
      authenticateWithSSO(authConnection, token)
    } else {
      window.location.href = `/invites/${encodeURIComponent(token)}/accept`
    }
  }

  const handleToggleAgree = () => {
    setAgree(!isAgreeing)
  }

  return (
    <AppWrapper type="funnel">
      <FunnelPage logo={<InfluxDataLogo />}>
        <Grid.Row>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <FlexBox
              direction={FlexDirection.Column}
              alignItems={AlignItems.Center}
              margin={ComponentSize.Large}
            >
              <FunnelHeader
                text={`You have been invited to join ${orgName}.`}
              />
              <FunnelSubheader
                text={`Complete the following to join as ${email}.`}
              />

              <Panel style={{maxWidth: '600px', width: '100%'}}>
                <Panel.Header size={ComponentSize.Medium}>
                  <Heading
                    element={HeadingElement.H3}
                    className="join-org--agree-header"
                  >
                    Read and agree to our service agreements
                  </Heading>
                </Panel.Header>
                <Panel.Body size={ComponentSize.Medium}>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column widthXS={Columns.Twelve}>
                        <LegalCheckbox
                          isError={isError}
                          isAgreeing={isAgreeing}
                          onToggleAgree={handleToggleAgree}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Panel.Body>
              </Panel>
              <CTAButton
                className="splash--cta-button"
                color={ComponentColor.Primary}
                type={ButtonType.Submit}
                text="Join Organization"
                onClick={handleJoin}
              />
            </FlexBox>
          </Grid.Column>
        </Grid.Row>
      </FunnelPage>
    </AppWrapper>
  )
}

export default JoinOrg
